<p-toast></p-toast>

<ng-container *ngIf="display === 'dialog'">
    <!-- Button to open the list -->
    <button pButton label="Tasks" type="button" (click)="showDialog()" icon="pi pi-check-square" class="mr-2" style="position: relative;" severity="help">
        <p-badge [value]="getPendingCount()" *ngIf="getPendingCount() > 0" severity="danger" [style]="{'position': 'absolute', 'top': '0', 'right': '0'}"></p-badge>
    </button>

    <!-- Main Dialog for listing tasks -->
    <p-dialog header="My Tasks" [(visible)]="visible" [modal]="true" [style]="{width: '90vw'}"
        [draggable]="false" [resizable]="false">
        <ng-template pTemplate="header">
            <div class="flex align-items-center justify-content-between w-full">
                <div class="flex align-items-center">
                    <i class="pi pi-check-square text-2xl mr-2"></i>
                    <h3 class="m-0">My Tasks</h3>
                    <p-badge [value]="getPendingCount()" severity="danger" class="ml-2"></p-badge>
                </div>
                <div class="flex align-items-center gap-2">
                    <p-selectButton [options]="filterOptions" [(ngModel)]="filter" optionLabel="label" optionValue="value"
                        (onChange)="loadTasks()"></p-selectButton>
                    <p-button label="New Task" icon="pi pi-plus" (click)="openNewTaskDialog()" class="mr-2"></p-button>
                </div>
            </div>
        </ng-template>
        <ng-container *ngTemplateOutlet="taskContent"></ng-container>
        <ng-template pTemplate="footer">
            <p-button icon="pi pi-times" (click)="visible = false" label="Close" styleClass="p-button-text"></p-button>
        </ng-template>
    </p-dialog>
</ng-container>

<div class="card" *ngIf="display === 'inline'">
    <div class="flex align-items-center justify-content-between w-full mb-3">
        <div class="flex align-items-center">
            <i class="pi pi-check-square text-2xl mr-2"></i>
            <h3 class="m-0">My Tasks</h3>
            <p-badge [value]="getPendingCount()" severity="danger" class="ml-2" *ngIf="getPendingCount() > 0"></p-badge>
        </div>
        <div class="flex align-items-center gap-2">
            <p-selectButton [options]="filterOptions" [(ngModel)]="filter" optionLabel="label" optionValue="value"
                (onChange)="loadTasks()"></p-selectButton>
            <p-button label="New Task" icon="pi pi-plus" (click)="openNewTaskDialog()" class="mr-2"></p-button>
        </div>
    </div>
    <ng-container *ngTemplateOutlet="taskContent"></ng-container>
</div>

<ng-template #taskContent>
    <p-table [value]="tasks" [paginator]="true" [rows]="25" [lazy]="true" (onLazyLoad)="loadTasks($event)"
    [totalRecords]="totalRecords" [loading]="loading" styleClass="p-datatable-sm p-datatable-striped" responsiveLayout="scroll">
    <ng-template pTemplate="header">
        <tr>
            <th>Task</th>
            <th>Assigned To</th>
            <th>Requested By</th>
            <th>Due Date</th>
            <th>Priority</th>
            <th>Status</th>
            <th style="width: 8rem">Action</th>
        </tr>
    </ng-template>
    <ng-template pTemplate="body" let-task>
        <tr [ngClass]="{'font-semibold': task.isPending}">
            <td>
                <div>{{ task.title }}</div>
                <small class="task-description text-color-secondary">{{ task.description }}</small>
            </td>
            <td>
                <div *ngIf="task.assignedTo" class="flex align-items-center">
                    <p-avatar [image]="task.assignedTo.profilePictureUrl || 'assets/default-avatar.png'"
                        shape="circle" class="mr-2"></p-avatar>
                    <span>{{ task.assignedTo.fullName }}</span>
                </div>
                <span *ngIf="!task.assignedTo">Unassigned</span>
            </td>
            <td>
                <div *ngIf="task.requestedBy" class="flex align-items-center">
                    <p-avatar [image]="task.requestedBy.profilePictureUrl || 'assets/default-avatar.png'" shape="circle" class="mr-2"></p-avatar>
                    <span>{{ task.requestedBy.fullName }}</span>
                </div>
            </td>
            <td>{{ task.dueDate | appDate:'medium' }}</td>
            <td>
                <p-tag [value]="task.priority" [severity]="getPrioritySeverity(task.priority)" [rounded]="true"></p-tag>
            </td>
            <td>
                <p-tag [value]="task.isPending ? 'Pending' : 'Completed'" [severity]="task.isPending ? 'info' : 'success'"></p-tag>
            </td>
            <td>
                <button *ngIf="task.workflowApprovalId" pButton pRipple type="button" label="View" icon="pi pi-eye" 
                    class="p-button-text" (click)="navigateToTask(task)" [disabled]="!task.routerLink" severity="info"></button>
                <button pButton pRipple type="button" label="Done" icon="pi pi-check-square" 
                    class="p-button-text" (click)="markAsCompleted(task)" [disabled]="!task.routerLink"></button>
            </td>
        </tr>
    </ng-template>
    <ng-template pTemplate="emptymessage">
        <tr>
            <td colspan="7" class="text-center p-4">You have no pending tasks. Great job!</td>
        </tr>
    </ng-template>
</p-table>
</ng-template>

<!-- Dialog for creating a new task -->
<p-dialog header="Create New Task" [(visible)]="taskFormDialogVisible" [modal]="true" [style]="{width: '40vw'}" (onHide)="taskForm.reset()">
    <form [formGroup]="taskForm" (ngSubmit)="saveNewTask()" class="p-fluid grid formgrid">
        <div class="field col-12">
            <p-inputgroup><p-inputgroup-addon><i class="pi pi-tag"></i></p-inputgroup-addon>
                <p-iftalabel><input id="title" type="text" pInputText formControlName="title" /><label for="title">Title</label></p-iftalabel>
            </p-inputgroup>
        </div>
        <div class="field col-12">
            <p-inputgroup><p-inputgroup-addon><i class="pi pi-align-left"></i></p-inputgroup-addon>
                <p-iftalabel><textarea id="description" pInputTextarea formControlName="description" rows="3" [style]="{'width': '100%'}"></textarea><label for="description">Description (Optional)</label></p-iftalabel>
            </p-inputgroup>
        </div>
        <div class="field col-6">
            <p-inputgroup><p-inputgroup-addon><i class="pi pi-sitemap"></i></p-inputgroup-addon>
                <p-iftalabel><p-dropdown inputId="businessObjectType" [options]="objectTypes" formControlName="businessObjectType" optionLabel="resourceName" placeholder="Select Type" styleClass="w-full" [appendTo]="'body'"></p-dropdown><label for="businessObjectType">Business Object Type</label></p-iftalabel>
            </p-inputgroup>
        </div>
        <div class="field col-6">
            <p-inputgroup><p-inputgroup-addon><i class="pi pi-hashtag"></i></p-inputgroup-addon>
                <p-iftalabel><input id="businessObjectId" pInputText formControlName="businessObjectId"><label for="businessObjectId">Object ID</label></p-iftalabel>
            </p-inputgroup>
        </div>
        <div class="field col-6">
            <p-inputgroup><p-inputgroup-addon><i class="pi pi-calendar"></i></p-inputgroup-addon>
                <p-iftalabel><p-calendar inputId="dueDate" formControlName="dueDate" [showIcon]="true" styleClass="w-full" [appendTo]="'body'"></p-calendar><label for="dueDate">Due Date</label></p-iftalabel>
            </p-inputgroup>
        </div>
        <div class="field col-6">
            <p-inputgroup><p-inputgroup-addon><i class="pi pi-flag"></i></p-inputgroup-addon>
                <p-iftalabel><p-dropdown inputId="priority" [options]="priorities" formControlName="priority" styleClass="w-full" [appendTo]="'body'"></p-dropdown><label for="priority">Priority</label></p-iftalabel>
            </p-inputgroup>
        </div>
        <div class="field col-12">
            <p-inputgroup><p-inputgroup-addon><i class="pi pi-user"></i></p-inputgroup-addon>
                <p-iftalabel><p-dropdown inputId="assignedTo" [options]="users" formControlName="assignedTo" optionLabel="fullName" optionValue="id" [showClear]="true" styleClass="w-full" [appendTo]="'body'"></p-dropdown><label for="assignedTo">Assign To</label></p-iftalabel>
            </p-inputgroup>
        </div>
    </form>
    <ng-template pTemplate="footer">
        <p-button label="Cancel" icon="pi pi-times" (click)="taskFormDialogVisible = false" styleClass="p-button-text"></p-button>
        <p-button label="Create Task" icon="pi pi-check" (click)="saveNewTask()" [disabled]="taskForm.invalid"></p-button>
    </ng-template>
</p-dialog>
